/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function UpdateUserRequestFromJSON(json) {
    return UpdateUserRequestFromJSONTyped(json, false);
}
export function UpdateUserRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        name: !exists(json, 'name') ? undefined : json['name'],
        firstName: !exists(json, 'firstName') ? undefined : json['firstName'],
        lastName: !exists(json, 'lastName') ? undefined : json['lastName'],
        email: !exists(json, 'email') ? undefined : json['email'],
    };
}
export function UpdateUserRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        name: value.name,
        firstName: value.firstName,
        lastName: value.lastName,
        email: value.email,
    };
}
